import ButtonBase from "@mui/material/ButtonBase";
import type {ColumnDef} from "@tanstack/react-table";
import type {DigitalSigningSummaryDTO} from "crqlar-react-common/dist/models/aggregation/reservationListAggregation.model";
import {DigitalSigningStatusElement} from "../../common/uiElements/DigitalSigningStatusElement";

// A button, so the table leaves the row's own click alone
const DigitalSigningCell = ({summary, onOpen}: {summary?: DigitalSigningSummaryDTO, onOpen: (id: string) => void}) => (
    summary ? (
        <ButtonBase onClick={() => onOpen(summary.id)} sx={{borderRadius: 1, maxWidth: '100%'}}>
            <DigitalSigningStatusElement status={summary.status}/>
        </ButtonBase>
    ) : null
);

/**
 * The reservation lists' Signature column, off by default: the status of the reservation's latest
 * signing link (its own or its package's, as the API puts it on the row); a click opens its signed page.
 */
export const createDigitalSigningColumn = <TData,>(
    header: string,
    summaryOf: (row: TData) => DigitalSigningSummaryDTO | undefined,
    onOpen: (id: string) => void,
): ColumnDef<TData> => ({
    id: 'digitalSigning',
    header,
    cell: ({row}) => <DigitalSigningCell summary={summaryOf(row.original)} onOpen={onOpen}/>,
    size: 150,
    meta: {
        defaultActive: false,
        printable: true,
        printCell: row => <DigitalSigningStatusElement status={summaryOf(row.original)?.status} asPrint/>,
    },
});
